import LicenseFeatureAccessAbout, {
  type LicenseFeatureAccessAboutPoint,
} from "@/v2-backoffice-client/license/changes/LicenseFeatureAccessAbout"

// The three things a reader of the Content view must know and cannot see
// in the rows: what content is (and that it is not a capability), where it
// comes from (the Layers and Base maps boards publish it; nothing is added
// here), and that every item arrives free until this board decides.
const POINTS: readonly LicenseFeatureAccessAboutPoint[] = [
  {
    key: "what",
    icon: "map",
    lead: "Content is what the map offers: base maps and map layers",
    text: "the two things the map checks a user for. A package can carry them whole (every map layer), by category, or one by one; a license or an add-on carries packages; a customer is on a license.",
  },
  {
    key: "who",
    icon: "layers",
    lead: "The Layers and Base maps boards make them",
    text: "an item appears here once it has a catalog row, and reaches users once the review queue has made it live and it has a country. Nothing is added, renamed or published from this board.",
  },
  {
    key: "decide",
    icon: "check-circle",
    lead: "Every item starts free for everyone",
    text: "the one decision per item is who should have it: keep it free, or make it package-only and name the packages that include it. Open an item to decide; the panel shows who would lose it before you save. A customer that takes only what is listed (Customers > What they get) gets an item only through its own packages, free or not.",
  },
]

function LicenseContentAbout() {
  return (
    <LicenseFeatureAccessAbout
      lead="Every base map and map layer arrives free for every customer. Open one to keep it free or make it package-only."
      points={POINTS}
    />
  )
}

export default LicenseContentAbout
